import { type MessageDescriptor } from 'react-intl'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GlobalSearchResultTabsStyled } from './styles/GlobalSearchResultTabsStyled'
import { GlobalSearchResultTabStyled } from './styles/GlobalSearchResultTabStyled'
import { GlobalSearchResultTypes } from '../../../../value-objects/enums'
import {
  GlobalSearchTabTypes,
  type GlobalSearchTab,
  type GlobalSearchTabTypeEnum,
} from '../../enums/GlobalSearchTabTypeEnum'

export interface IGlobalSearchResultTabsProps {
  tabs: GlobalSearchTab[]
  selectedTab: GlobalSearchTabTypeEnum
  onTabClick: (type: GlobalSearchTabTypeEnum) => void
}

const TAB_MESSAGES: Record<GlobalSearchTabTypeEnum, MessageDescriptor> = {
  [GlobalSearchTabTypes.ALL]: messages.allTab,
  [GlobalSearchResultTypes.ORDER_REQUEST]: messages.orderRequestTab,
  [GlobalSearchResultTypes.EXPENSE_REQUEST]: messages.expenseRequestTab,
  [GlobalSearchResultTypes.TRAVEL_REQUEST]: messages.travelRequestTab,
  [GlobalSearchResultTypes.PURCHASE_ORDER]: messages.purchaseOrderTab,
  [GlobalSearchResultTypes.BILL]: messages.billTab,
  [GlobalSearchResultTypes.PAYMENT]: messages.paymentTab,
  [GlobalSearchResultTypes.CATALOG_ITEM]: messages.catalogItemTab,
  [GlobalSearchResultTypes.VENDOR]: messages.vendorTab,
}

export const GlobalSearchResultTabs = ({
  tabs,
  selectedTab,
  onTabClick,
}: IGlobalSearchResultTabsProps) => {
  const intl = useProcurifyIntl()

  return (
    <GlobalSearchResultTabsStyled role='tablist'>
      {tabs.map((tab) => {
        const isSelected = tab.type === selectedTab

        return (
          <GlobalSearchResultTabStyled
            key={tab.type}
            role='tab'
            isSelected={isSelected}
            aria-selected={isSelected}
            tabIndex={isSelected ? 0 : -1}
            onClick={() => onTabClick(tab.type)}
          >
            {intl.formatMessage(TAB_MESSAGES[tab.type], { count: tab.count })}
          </GlobalSearchResultTabStyled>
        )
      })}
    </GlobalSearchResultTabsStyled>
  )
}
